import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import type { UserRole } from '@/types/auth';

const STYLES: Record<UserRole, string> = {
  admin: 'bg-brand-red/10 text-brand-red',
  mago: 'bg-purple-500/10 text-purple-400',
  approacher: 'bg-info/10 text-info',
  collector: 'bg-surface-secondary text-text-secondary',
};

const LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  mago: 'Mago',
  approacher: 'Approacher',
  collector: 'Collector',
};

export function RoleBadge({ role }: { role: UserRole }): ReactNode {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-sm px-1.5 py-0.5 text-xs font-medium',
        STYLES[role] ?? STYLES.collector
      )}
    >
      {LABELS[role] ?? role}
    </span>
  );
}
